export default __webpack_public_path__ + "static/media/assessment-profile.50295953.png";